import type { CompetitorQuerySchema } from '../schemas';

export const fieldNames: Record<keyof CompetitorQuerySchema, { name: string; revertible: boolean }> = {
  name: { name: 'Competitor Name', revertible: true },
  status: { name: 'Status', revertible: true },
  business_tagline: { name: 'Business Tagline', revertible: true },
  number_of_customers: { name: 'Number of Customers', revertible: true },
  founded_date: { name: 'Founded Date', revertible: true },
  headcount: { name: 'Headcount', revertible: true },
  email: { name: 'Email', revertible: true },
  website: { name: 'Website', revertible: true },
  pricing_strategy: { name: 'Pricing Strategy', revertible: true },
  tidbits: { name: 'Interesting Tidbits', revertible: true },
  weaknesses: { name: 'Weaknesses', revertible: true },
  strengths: { name: 'Strengths', revertible: true },
  how_to_win: { name: 'How Can We Win', revertible: true },
  phone_numbers: { name: 'Phone Numbers', revertible: true },
  addresses: { name: 'Addresses', revertible: true },
  primary_contact: { name: 'Contacts', revertible: true },

  logo: { name: 'Logo', revertible: true },

  associated_clients: { name: 'Associated Companies', revertible: true },
  current_web_clients: { name: 'Current Web Companies', revertible: true },

  id: { name: 'ID', revertible: false },
  behavior: { name: 'Behavior', revertible: false },
  glassdoor_url: { name: 'Glassdoor Url', revertible: false },
  associated_clients_count: { name: 'Companies', revertible: false },
  primary_contact_count: { name: 'Contacts', revertible: false },
  ceo_contact: { name: 'CEO Contacts', revertible: false },

  current_web_clients_count: { name: 'Current Web Companies', revertible: false },
  // creator_id: {
  //   name: 'Creator ID',
  //   revertible: false,
  // },
};
